import "./styles.scss";
import PropTypes from "prop-types";

function ErrorCard({ errorText = "Error" }) {
  return (
    <div className="flex flex-col items-center justify-center w-full h-full pt-8">
      <span className="error-text text-base font-semibold mb-2">{errorText}</span>
    </div>
  );
}

export default ErrorCard;

ErrorCard.propTypes = {
  errorText: PropTypes.string,
};
